export default __webpack_public_path__ + "assets/icons/contact-service.d4090b78.svg";